import { type ReactNode } from 'react'
import { Box, Icon, type ITooltipProps, Status, Switch, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IAgentSwitchFieldProps = {
  active: boolean
  onChange: (value: boolean) => void
  isBeta?: boolean
  title: string
  questionInfoTooltip?: ReactNode
  disabled?: boolean
  switchTooltipProps?: ITooltipProps
}

export const AgentSwitchField = ({
  active,
  onChange,
  isBeta,
  title,
  questionInfoTooltip,
  disabled,
  switchTooltipProps,
}: IAgentSwitchFieldProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Box gap={0.5} display={'flex'} alignItems={'center'}>
          <Typography ariaLabel={title} variant={'text-input-field-r'}>
            {title}
          </Typography>
          {questionInfoTooltip && (
            <Tooltip placement={'top'} label={questionInfoTooltip} breakWord>
              <Box
                height={16}
                width={16}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Icon icon={'question'} color={'var(--content-neutral-primary)'} fontSize={13} />
              </Box>
            </Tooltip>
          )}

          {isBeta && <Status title={'Beta'} intent={'warning'} emphasis={'high'} size={'label'} />}
        </Box>
        <Switch
          value={active}
          size={'small'}
          onChange={onChange}
          disabled={disabled}
          tooltipProps={switchTooltipProps}
        />
      </div>
    </div>
  )
}
